<template>
  <div class="col-auto">
    <model-table
      :collection="journalEntries"
      :show-add="!!initialDate"
      add-label="Manual Entry"
      :columns="[
        { field: 'id' },
        { field: 'date' },
        { field: 'accountSource', component: 'model' },
        { field: 'state', component: 'chip' },
        { field: 'description' },
        { field: 'manual', component: 'checkmark' },
        { field: 'amount', component: 'money' },
        { name: 'actions', align: 'right' }
      ]"
    >
      <template
        v-if="!initialDate"
        #header-controls
      >
        <iso-date-input
          v-model="date"
          emit-string="allow-blank"
          class="col-auto"
          label="Date"
          clearable
        />
      </template>

      <journal-entry-form />
    </model-table>
  </div>
</template>

<script>
import IsoDateInput from 'src/modules/admin/components/IsoDateInput'
import ModelTable from 'src/modules/admin/components/ModelTable'
import JournalEntryForm from 'src/modules/admin/journal-entry/JournalEntryForm'

export default {
  name: 'JournalEntryTable',
  components: {
    IsoDateInput,
    ModelTable,
    JournalEntryForm
  },
  props: {
    initialDate: {
      type: String,
      required: false,
      default: null
    }
  },
  data () {
    return {
      date: this.initialDate
    }
  },
  watch: {
    initialDate () {
      this.date = this.initialDate
    }
  },
  models: {
    journalEntries: {
      accountSource: true,
      variables () {
        return {
          date: this.date
        }
      }
    }
  }
}

</script>
